module.exports = __webpack_public_path__ + "img/power-tail-good.3effbc12.svg";